<div class="ap-skeleton__paragraph" aria-live="polite" aria-busy="true">
    @for (row of rowArray; track $index) {
        <span></span>
    }
</div>
